/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 搜索历史同步
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  userSearchHistory: good.UserSearchHistory,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.UserSearchHistory;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/good/search-sync`,
    data: userSearchHistory,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
